import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import RiskAssessmentDashboard from './pages/risk-assessment-dashboard';
import TradingDashboardOverview from './pages/trading-dashboard-overview';
import TradeExecutionManagement from './pages/trade-execution-management';
import MarketDataIntegrationHub from './pages/market-data-integration-hub';
import LiveTradingFeed from './pages/live-trading-feed';
import PortfolioPerformanceAnalytics from './pages/portfolio-performance-analytics';
import AIOraclePredictions from './pages/ai-oracle-predictions';
import MultiAgentSystem from './pages/multi-agent-system';
import VoiceInterfaceVAMCC from './pages/voice-interface-vamcc';
import UltraFastTrading from './pages/ultra-fast-trading';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<TradingDashboardOverview />} />
        <Route path="/risk-assessment-dashboard" element={<RiskAssessmentDashboard />} />
        <Route path="/trading-dashboard-overview" element={<TradingDashboardOverview />} />
        <Route path="/trade-execution-management" element={<TradeExecutionManagement />} />
        <Route path="/market-data-integration-hub" element={<MarketDataIntegrationHub />} />
        <Route path="/live-trading-feed" element={<LiveTradingFeed />} />
        <Route path="/portfolio-performance-analytics" element={<PortfolioPerformanceAnalytics />} />
        <Route path="/ai-oracle-predictions" element={<AIOraclePredictions />} />
        <Route path="/multi-agent-system" element={<MultiAgentSystem />} />
        <Route path="/voice-interface-vamcc" element={<VoiceInterfaceVAMCC />} />
        <Route path="/ultra-fast-trading" element={<UltraFastTrading />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
